<template>
  <div class="user-content-section">
    <div class="page-sub-title user-sub-title">
      <h2>
        <i class="fa-title"></i>
        <div>{{ $t("my_certificates") }}</div>
      </h2>
    </div>
    <div class="courses-all-list" v-if="certificates">
      <div class="courses-item" v-for="cer in certificates" :key="cer.id">
        <div class="courses-item-photo">
          <img src="../../assets/images/courses/certificate-icon.svg" alt="" />
          <div class="courses-item-progres">
            <span class="progres-line" style="width: 100%"></span>
          </div>
        </div>
        <div class="courses-item-content">
          <div class="courses-info">
            <a>{{ cer.name || cer.course_name }}</a>
          </div>
          <div class="courses-purchase">
            <div class="courses-price">
              <span class="no">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 0C3.14005 0 0 3.14005 0 7C0 10.86 3.14005 14 7 14C10.86 14 14 10.86 14 7C14 3.14005 10.86 0 7 0ZM10.3291 10.6207C10.2153 10.7345 10.066 10.7917 9.9167 10.7917C9.76738 10.7917 9.61795 10.7345 9.5043 10.6207L6.5876 7.7041C6.47791 7.59505 6.4167 7.44679 6.4167 7.2917V3.5C6.4167 3.17743 6.67796 2.9167 7 2.9167C7.32204 2.9167 7.5833 3.17743 7.5833 3.5V7.0502L10.3291 9.7959C10.5571 10.024 10.5571 10.3927 10.3291 10.6207Z"
                    fill="#C5D2DE"
                  />
                </svg>
                {{
                  new Intl.DateTimeFormat("ru-RU").format(
                    new Date(cer.finished_date || cer.created_at),
                  )
                }}
              </span>
            </div>
            <button
              @click="viewCertificateDetails(cer)"
              class="courses-btn"
              :disabled="!cer.pdf && !cer.certificate_url"
            >
              <div>{{ $t("details") }}</div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>{{ $t("my_certificates_desc") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  title: "Sertifikatlarim",
  async beforeCreate() {
    await this.$store.dispatch("getCertificates");
  },
  methods: {
    viewCertificateDetails(certificate) {
      // Try to open PDF if available
      if (certificate.pdf) {
        window.open(certificate.pdf, "_blank");
      } else if (certificate.certificate_url) {
        window.open(certificate.certificate_url, "_blank");
      } else {
        // If no PDF is available, show a message or navigate to a details page
        this.$store.commit("setError", "Sertifikat fayli mavjud emas");
        // Alternatively, you could navigate to a details page:
        // this.$router.push(`/certificates/${certificate.id}`);
      }
    },
  },
  computed: {
    certificates() {
      return this.$store.getters.getCertificates;
    },
  },
  components: {},
};
</script>
